<template>

    <div class="swatch" :style="styles"></div>

</template>

<style scoped lang="scss">

    .swatch {
        flex-shrink: 0;
    }

</style>

<script>

export default {

    props: {
        color: {
            type: String,
            required: true,
        },
        size: {
            type: Number,
            default: 30,
        },
        radius: {
            type: Number,
            default: 3,
        },
    },

    computed: {

        styles() {
            return {
                'background-color': this.color,
                'border-radius': `${this.radius}px`,
                'width': `${this.size}px`,
                'height': `${this.size}px`,
            }
        },

    },

}

</script>
